/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonContractExecutedTrxInfo = {
    TRXHA: string;
    STAT: BabylonContractExecutedTrxInfo.STAT;
    MSGTPLIST: Array<string>;
    BNO: string;
    TRXF: string;
    TRXFVAL: string;
    AG: string;
    UT: number;
};

export namespace BabylonContractExecutedTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

